export default __webpack_public_path__ + "static/media/pexels-pixabay-248874.63d9540a.jpg";